export const useObjectUtils = () => {

    const _isPlainObject = (value: unknown): value is Record<string, unknown> => {
        return typeof value === 'object' && value !== null && !Array.isArray(value);
    }

    const deepMerge = <T>(base: T, patch: Partial<T>): T => {
        const result = { ...base } as Record<string, unknown>;

        for (const [key, patchValue] of Object.entries(patch as Record<string, unknown>)) {
            const baseValue = result[key];

            if (patchValue === undefined) {
                continue;
            }

            if (_isPlainObject(baseValue) && _isPlainObject(patchValue)) {
                result[key] = deepMerge(baseValue, patchValue);
            } else {
                result[key] = patchValue;
            }
        }

        return result as T;
    }

    return {
        deepMerge
    }
}